import { domMax } from 'motion/react'

export default domMax
